import { FaAngleLeft } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

function TopSection({ id }) {
  const navigate = useNavigate();
  const handleBack = () => {
    navigate(`/detail/${id}`);
  };

  return (
    <div
      onClick={handleBack}
      className="flex cursor-pointer items-center px-4 phone:px-32"
    >
      <FaAngleLeft className="icono hover:text-danger" />
      <h1 className="text-5xl font-bold inline-block">Comprar e-tickets</h1>
    </div>
  );
}

export { TopSection };
